import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './utils/local-storage';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { authManager } from './helpers/managers';
import { subscribeToCategories, openUserChannel } from './actions/index';
import ScrollToTop from './components/scroll_to_top';
import SoundwiseCheckout from './containers/checkout';
import ContentDownload from './components/content_download';
import { OrderConfirmation } from './components/order_confirmation';
import Notice from './components/notice';
import AppSignup from './containers/signup';
import AppSignin from './containers/signin';
import Pricing from './containers/Pricing';
import SignupOptions from './containers/signup_options';
import { SettingNewSoundcast } from './containers/setting_new_soundcast';
import MySoundcasts from './containers/mysoundcasts';
import SoundcastPlayer from './containers/mysoundcasts/SoundcastPlayer';
import UserProfile from './containers/profile';
import Dashboard from './containers/dashboard';
import { SoundcastCheckout } from './containers/soundcast_landing_page/soundcast_checkout';
import { SoundcastCheckout2 } from './containers/soundcast_landing_page/soundcast_checkout2';
import NotFound from './components/page_404';
import PassRecovery from './components/pass_recovery';
import { WaveVideoInputs } from './containers/wave_video_inputs';

if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'staging') {
  console.log(`Running "${process.env.NODE_ENV}" mode`);
}

class Routes extends Component {
  componentDidMount() {
    authManager.onAuthStateChanged(user => {
      if (!user) {
        // TODO: if user does not exist, force logout
        return;
      }

      // open users channel
      this.props.openUserChannel(user.uid);

      // TODO: identify if this still needed
      this.props.subscribeToCategories();
    });
  }

  render() {
    return (
      <Router>
        <ScrollToTop>
          <React.Fragment>
            <Helmet>
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://mysoundwise.com/" />
              <meta
                property="og:title"
                content="Soundwise - Leading Platform for Audio Monetization | Sell Your Audios Online, Deliver to Mobile Devices"
              />
              <meta property="fb:app_id" content="1726664310980105" />
              <meta
                property="og:description"
                content="Soundwise is the premier platform for selling audio courses, audiobooks, premium podcasts and other audio programs. Build your audio streaming service, market your audios & deliver straight to your listeners’ phones."
              />
              <meta
                property="og:image"
                content="https://mysoundwise.com/images/soundwise-home.png"
              />
              <title>
                Soundwise - Leading Platform for Audio Monetization | Sell Your Audios Online,
                Deliver to Mobile Devices
              </title>
              <meta
                name="description"
                content="Soundwise is the premier platform for selling audio courses, audiobooks, premium podcasts and other audio programs. Build your audio streaming service, market your audios & deliver straight to your listeners’ phones."
              />
              <meta
                name="keywords"
                content="soundwise, podcast hosting, sell audios, on-demand audios, audio courses, podcast conversion, podcasting, audio training, online education, podcast software, soundwise, audio publishing, content management system, audio learning, online learning, online course, podcast mobile app"
              />
            </Helmet>
            <Switch>
              <Route
                exact
                path="/"
                render={props => <Dashboard {...{ fromindex: true, ...props }} />}
              />
              <Route
                exact
                path="/dashboard"
                render={props => <Dashboard {...{ fromindex: true, ...props }} />}
              />
              <Route path="/buy" component={SoundwiseCheckout} />
              <Route path="/content_download" component={ContentDownload} />
              <Route path="/confirmation" component={OrderConfirmation} />
              <Route exact={true} path="/dashboard/:tab" component={Dashboard} />
              <Route path="/dashboard/:tab/:id" component={Dashboard} />
              <Route exact path="/mysoundcasts" component={MySoundcasts} />
              <Route exact path="/mysoundcasts/:soundcastId" component={SoundcastPlayer} />
              <Route
                exact
                path="/mysoundcasts/:soundcastId/:episodeId"
                component={SoundcastPlayer}
              />
              <Route exact path="/myprofile" component={UserProfile} />
              <Route path="/notice" component={Notice} />
              <Route path="/notfound" component={NotFound} />
              <Route path="/password_reset" component={PassRecovery} />
              <Route exact={true} path="/signup/:mode" component={AppSignup} />
              <Route path="/signup/:mode/:id" component={AppSignup} />
              <Route path="/signup_options" component={SignupOptions} />
              <Route path="/signin/:mode/:id" component={AppSignin} />
              <Route
                exact={true}
                path="/signin/transition"
                render={props => <AppSignin {...{ transition: true, ...props }} />}
              />
              <Route exact={true} path="/signin" component={AppSignin} />
              <Route path="/setting_new_soundcast" component={SettingNewSoundcast} />
              <Route path="/soundcast_checkout" component={SoundcastCheckout2} />
              <Route path="/soundcast_checkout2" component={SoundcastCheckout} />
              <Route path="/pricing" component={Pricing} />
              <Route path="/wave_video" component={WaveVideoInputs} />
              <Route component={NotFound} />
            </Switch>
          </React.Fragment>
        </ScrollToTop>
      </Router>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  subscribeToCategories,
  openUserChannel,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);
